export const  GET_PRODUCT_REQUEST  = "GET_PRODUCT_REQUEST"
export const  GET_PRODUCT_SUCCESS  = "GET_PRODUCT_SUCCESS"
export const  GET_PRODUCT_FAILURE  = "GET_PRODUCT_FAILURE"

export const  GET_PRODUCT_TOTAL_REQUEST  = "GET_PRODUCT_TOTAL_REQUEST"
export const  GET_PRODUCT_TOTAL_SUCCESS  = "GET_PRODUCT_TOTAL_SUCCESS"
export const  GET_PRODUCT_TOTAL_FAILURE  = "GET_PRODUCT_TOTAL_FAILURE"




